module.exports = __webpack_public_path__ + "static/media/Compass-Lease-1920x1080-8.2f5051c4.png";